import React from 'react';
import { useNavigate } from 'react-router-dom';
import apiClient from '../Api/apiClient';

export const TenderPublishPayment = ({ isOpen, onClose, tenderData }) => {
  const navigate = useNavigate();

  const userType = localStorage.getItem('user_type');
  const {
    id,
    regular_amount,
    discount_percent,
    discount_amount,
    sub_total,
    ten_req_id,
  } = tenderData;

  // console.log(tenderData)

  if (!isOpen) return null;

  const handlePayNow = async () => {
    try {
      let url = 'user/payment/tender-request-pay';
      if (userType === 'affiliator') {
        url = '/affiliator/payment/tender-request-pay';
      }
      const response = await apiClient.post(url, {
        regular_amount: regular_amount,
        discount_percent: discount_percent,
        discount_amount: discount_amount,
        sub_total: sub_total,
        ten_req_id: ten_req_id,
      });

      if (response.data?.checkout_url) {
        window.location.href = response.data.checkout_url;
      } else {
        console.error('No link found in response:', response.data);
      }
    } catch (error) {
      console.error('Error posting data:', error);
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-15 z-50">
      <div className="bg-white rounded-lg p-6 shadow-lg text-center max-w-md w-full relative">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-700 text-lg font-bold"
        >
          &times;
        </button>

        {/* Modal Title */}
        <h2 className="text-xl font-bold text-gray-800 mb-6">Check out</h2>

        {/* Payment Details */}
        <div className="bg-gray-50 p-4 rounded-md">
          <div className="flex justify-between items-center mb-3">
            <span className="text-gray-700">Amount</span>
            <span className="text-gray-900 font-semibold">
              ৳ {regular_amount}
            </span>
          </div>
          <div className="flex justify-between items-center mb-3">
            <span className="text-gray-700">Discount {discount_percent}%</span>
            <span className="text-gray-900 font-semibold">
              ৳ {discount_amount}
            </span>
          </div>
          <hr className="border-gray-300 mb-3" />
          <div className="flex justify-between items-center">
            <span className="text-gray-900 font-semibold">Total</span>
            <span className="text-orange-500 font-bold">৳ {sub_total}</span>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex justify-center gap-4 mt-6">
          <button
            onClick={onClose}
            className="border-2 border-orange-500 text-orange-500 hover:bg-orange-100 py-2 px-4 rounded-md font-medium"
          >
            Cancel
          </button>
          <button
            onClick={handlePayNow}
            className="bg-orange-500 hover:bg-orange-600 text-white py-2 px-4 rounded-md font-medium"
          >
            Pay now
          </button>
        </div>
      </div>
    </div>
  );
};
